import { useDraggable } from '@dnd-kit/core';
import { format } from 'date-fns';
import { Shift } from '../../services/rosterService';

interface ShiftItemProps {
    shift: Shift;
}

const ShiftItem = ({ shift }: ShiftItemProps) => {
    const { attributes, listeners, setNodeRef, transform } = useDraggable({
        id: shift.id,
        data: shift
    });

    const style = transform ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    } : undefined;

    const getShiftColor = (type: string) => {
        switch (type) {
            case 'CLEARER':
                return 'bg-blue-100 border-blue-200 text-blue-900';
            case 'LHR':
                return 'bg-rose-100 border-rose-200 text-rose-900';
            case 'CONTROL':
                return 'bg-purple-100 border-purple-200 text-purple-900';
            case 'OFFICE':
                return 'bg-gray-100 border-gray-200 text-gray-900';
            case 'WAREHOUSE':
                return 'bg-yellow-100 border-yellow-200 text-yellow-900';
            default:
                return 'bg-gray-100 border-gray-200 text-gray-900';
        }
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...listeners}
            {...attributes}
            className={`p-2 mb-1 rounded text-xs cursor-move shadow-sm border touch-manipulation ${getShiftColor(shift.type)}`}
        >
            <div className="font-bold flex justify-between items-center">
                <span className="truncate">{shift.user.name}</span>
                <span className="ml-2 text-xs opacity-75">{shift.type}</span>
            </div>
            {(shift as any).location && (
                <div className="text-xs mt-0.5 opacity-75">
                    📍 {(shift as any).location}
                </div>
            )}
            <div className="text-xs mt-1">
                {format(new Date(shift.startTime), 'HH:mm')} - {format(new Date(shift.endTime), 'HH:mm')}
            </div>
        </div>
    );
};

export default ShiftItem;
